import api from '@/api'

export default {
  // 获取列表
  getFootballByYouth (params) {
    return api({
      url: '/facility/football/footballListYouth',
      method: 'GET',
      params
    })
  },
  // 获取列表
  getFootballByOrgan (params) {
    return api({
      url: '/facility/football/footballListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取列表,system
  getFootballBySystem (params) {
    return api({
      url: '/facility/football/footballListSystem',
      method: 'GET',
      params
    })
  },

  // 添加
  addFootball (data) {
    return api({
      url: '/facility/football/footballAdd',
      method: 'POST',
      data
    })
  },
  // 修改信息
  updataFootball (data) {
    return api({
      url: '/facility/football/footballEdit',
      method: 'POST',
      data
    })
  },
  // 删除
  deleteFootball (uuid) {
    return api({
      url: `/facility/football/footballDelete/${uuid}`,
      method: 'POST'
    })
  },
  // 获取信息
  getFootballInfo (uuid) {
    return api({
      url: `/facility/football/footballInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 获取信息
  getAssistInfoYouth () {
    return api({
      url: `/facility/assist/assistInfoYouth`,
      method: 'GET'
    })
  },
  // 修改信息
  assistEdit (data) {
    return api({
      url: '/facility/assist/assistEdit',
      method: 'POST',
      data
    })
  },
  // 获取列表,system
  assistListSystem (params) {
    return api({
      url: '/facility/assist/assistListSystem',
      method: 'GET',
      params
    })
  },
  // 获取信息
  assistInfoSystem (uuid) {
    return api({
      url: `/facility/assist/assistInfoSystem/${uuid}`,
      method: 'GET'
    })
  },
}
